import script from "./VodCategoryProgressChart.vue?vue&type=script&setup=true&lang=js"
export * from "./VodCategoryProgressChart.vue?vue&type=script&setup=true&lang=js"

import "./VodCategoryProgressChart.vue?vue&type=style&index=0&id=3a81d74c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a81d74c"]])

export default __exports__